/*
 *
 * PortalTextBlocked
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 27-Jun-2024
 */

import { connect } from 'react-redux'

import PortalTextBlocked from './PortalTextBlocked'

const mapDispatchToProps = () => ({})

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(PortalTextBlocked)
